import { get_direction, sort_elements } from "../../sort/index.ts";
import type { JournalSort } from "../../stores/journal.ts";

export type JournalSortColumn = "date" | "flag" | "narration" | "change";

const journal_column_types = {
  date: "num",
  flag: "string",
  narration: "string",
  change: "num",
};

const journal_column_selectors = {
  date: ".datecell",
  flag: ".flag",
  narration: ".description",
  change: ".change",
};

export function sort_journal(ol: HTMLOListElement, sort: JournalSort): void {
  const [column, order] = sort;
  const type = journal_column_types[column];
  const selector = journal_column_selectors[column];
  sort_elements<HTMLLIElement>(
    ol,
    [].slice.call(ol.children),
    (li) => li.querySelector(selector),
    get_direction(order),
    type,
  );
}
